export const IntranetClaim = {
    path: '/intranet_claims',
    name: 'intranet_claims',
    component: () => import('@/views/Intranet/IntranetClaimPage.vue'),
    children: [
        {
            path: '/intranet_claims/add',
            name: 'intranet_claims.add',
            component: () => import('@/views/Request/Claim/Form/ClaimForm.vue'),
            props: {addAction: true, intranet: true}
        },
        {
            path: '/intranet_claims/edit/:id',
            name: 'intranet_claims.edit',
            component: () => import('@/views/Request/Claim/Form/ClaimForm.vue'),
            props: {updateAction: true, intranet: true}
        },
        {
            path: '/intranet_claims/delete/:id',
            name: 'intranet_claims.delete',
            component: () => import('@/views/Request/Claim/Form/ClaimForm.vue'),
            props: {deleteAction: true, intranet: true}
        },
        {
            path: '/intranet_claims/view/:id',
            name: 'intranet_claims.view',
            component: () => import('@/views/Request/Claim/Form/ClaimForm.vue'),
            props: {viewAction: true, intranet: true}
        },
        {
            path: '/intranet_claims/set_decision/:id/:module',
            name: 'intranet_claims.set_decision',
            component: () => import('@/views/Request/Components/SetDecision.vue'),
        },
        {
            path: '/intranet_claims/take_in_charge/:id/:module',
            name: 'intranet_claims.take_in_charge',
            component: () => import('@/views/Request/Components/TakeInCharge.vue'),
        },
        {
            path: '/intranet_claims/timelines/:id/:module',
            name: 'intranet_claims.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines'),
        },
      {
        path: '/intranet_claims/documents/:id',
        name: 'intranet_claims.documents',
        component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
        props: {module: "CLAIM"}
      },
    ],
}